export function timestamp(enabled) {
    if (enabled) {
        return performance.now();
    }
    return undefined;
}
//# sourceMappingURL=time.js.map